<template>
  <div id="smartTown">
    <div class="title">三级医院评审标准（2020年版）</div>
    <div class="text">根据国家法律法规及相关规定，建立和完善医学装备管理组织架构，加强大型医用设备配置管理。有健全医学装备档案管理制度与完整的档案资料，具备社会效益、临床使用效果、应用质量功能开发程序等分析；有保障装备处于完好状态的制度与规范，对用于急救、生命支持系统仪器装备要始终保持在待用状态；有医疗器械临床使用安全事件监测与报告的追踪分析资料等。</div>
    <div class="btn" @click="toLink()">查看详情</div>
   
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
  methods:{
    toLink(){
      window.open('http://www.nhc.gov.cn/yzygj/s7657/202012/c46f97f475da4d60be21641559417aaf.shtml')
    }
  }
};
</script>
<style scoped>
.btn{
  margin: 40px auto 20px;
  display: block;
  border-radius: 4px;
  width: 80px;
  color: #1e73be;
  border: 1px solid #1e73be;
}
.btn:hover{
  color: #1e73be ;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 15px;
  margin-right: 20px;
  text-indent: 28px
}
.sub-title{
  color: #666;
  font-size: 18px;
  text-align: center;
}
.right{
  text-align: right;
  color: #666;
  font-size: 20px;
}
.title{
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
}
.title1{
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/view/news3.vue